import * as NewsStore from './store'

export function newsModule({ store }) {
  store.registerModule('news', { ...NewsStore, namespaced: true })
}
